export default __webpack_public_path__ + "static/media/vincennes6.074a9a49.jpg";